/* istanbul ignore file */
export const environment = {
    version: require('../../package.json').version + '-tst',
    production: false,
    api: 'https://smarts-tst.kimley-horn.com/api/',
    url: 'https://smarts-tst.kimley-horn.com/',
    blobStorage: 'https://sasmartsplatformtst.blob.core.windows.net/',
    name: 'SMARTS Platform',
    colors: {
        primaryColor: '#592c82',
        primaryVariantColor: '#835ea0',
        primaryTextColor: '#ffffff',
        primaryBlackColor: "#424553",
        secondaryColor: "#e6e6e6",
        secondaryVariantColor: "#bdbdbd",
        secondaryTextColor: '#353a40',
        backgroundColor: '#ffffff',
        surfaceColor: '#ffffff',
        errorColor: '#a20c33',
    },
    logos: {
        primaryLogo: 'assets/logo-color-primary.svg',
        secondaryLogo: 'assets/logo-color-secondary.png',
    },
    azure: {
        scopes: 'api://d66a8456-6c33-4f3c-90dd-6344b0abcc0d/access_as_user',
        clientId: 'd66a8456-6c33-4f3c-90dd-6344b0abcc0d',
        redirectUri: 'https://smarts-tst.kimley-horn.com/home'
    },
    entraId: {
        tenantId: '7e220d30-0b59-47e5-8a81-a4a9d9afbdc4',
        scopes: 'api://2d3fc98d-3d37-46d5-865b-e1ad7e5afc38/API.Access.User',
        clientId: '2d3fc98d-3d37-46d5-865b-e1ad7e5afc38',
        redirectUri: 'https://smarts-tst.kimley-horn.com/home',
        authority: 'https://login.microsoftonline.com/7e220d30-0b59-47e5-8a81-a4a9d9afbdc4'
    },
    entraExternalId: {
        tenantId: '33028fa1-73e4-4c25-8e12-e37782a3ab6e',
        scopes: 'https://smarts-tst.kimley-horn.com/API.Access.User',
        clientId: 'f0316df5-4386-42c2-a9b5-9e4e71375809',
        redirectUri: 'https://smarts-tst.kimley-horn.com/home',
        authority: 'https://khtstst.ciamlogin.com/33028fa1-73e4-4c25-8e12-e37782a3ab6e'
    },
    internalUserDomains: ['kimley-horn.com', 'kimley-horndc.com'],
    outerHeight: 149,
    developement: false,
    serviceRequestApi: 'https://app-khtscore-servicerequest-tst-southcentralus.azurewebsites.net/ServiceRequest',
    appInsights: {
        instrumentationKey: '470a7ebd-ce01-45c2-b41c-b6ac8cdf3309'
    },
    googleMaps: {
        mapIds: {
            streetLabelsNoPOI: '2121d18117d748eae993fcc6',
            noStreetLabelsNoPOI: '2121d18117d748ea8a7bd84b',
            streetLabelsPOI: '2121d18117d748ea1fa97a9b',
            noStreetLabelsPOI: '2121d18117d748eaa609e86e'
        }
    }
};
